export default (shouldSuppress: boolean = true) => {};
